import React from 'react';
import Layout from '../components/Layout';
import CustomerForm from '../components/CustomerForm';

const CustomerCreation = () => {
  return (
    <Layout>
      <CustomerForm mode="create" />
    </Layout>
  );
};

export default CustomerCreation;
